import { getAuthServiceUrl, getDiceServiceUrl } from "@/constants";
import type { DiceData } from "@/types";
import { getJwt } from "@dndbeyond/auth/browserAuth";

export const postNewSettings = async (
  newSettings: DiceData["settings"],
  nodeEnv: string,
  env: string,
) => {
  await fetch(
    `${getDiceServiceUrl(nodeEnv, env)}/diceuserconfig/v1/updatesettings`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await getJwt(
          new URL(getAuthServiceUrl(nodeEnv, env)),
          {
            credentials: "include",
            useCache: false,
            parseToken: false,
          },
        )}`,
      },
      body: JSON.stringify(newSettings),
    },
  );
};
